/**
 * A rate limit wait as a reader says it: "40 s" under a minute, "9 min 58 s"
 * or "10 min" above. Used after "Try again in", "Retry in", "Load more in".
 */
export function formatRateLimitWait(seconds: number): string {
  if (seconds < 60) return `${seconds} s`;
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return rest === 0 ? `${minutes} min` : `${minutes} min ${rest} s`;
}
